var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container role-box" },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "系统管理", url: "" },
                { label: "角色管理", url: "" }
              ]
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "role-top" },
        [
          _c("search-form", {
            attrs: { "form-data": _vm.searchFormData, "btn-type": _vm.btnType },
            on: {
              searchForm: _vm.searchForm,
              exportTable: _vm.exportTable,
              changeSelect: _vm.getChangeSelect,
              addTable: _vm.addRole,
              resetForm: _vm.resetForm
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "role-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.showLoading,
                  expression: "showLoading"
                }
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                "element-loading-custom-class": "loadingSize",
                "element-loading-background": "rgba(0, 0, 0, 0.2)",
                data: _vm.tableData,
                border: "",
                "highlight-current-row": "",
                height: _vm.tableheight,
                "tooltip-effect": "dark"
              },
              on: {
                "header-dragend": _vm.headerdragend,
                "selection-change": _vm.handleSelectionChange
              }
            },
            [
              _c("template", { slot: "empty" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("no-data", {
                      attrs: { height: "400px", width: "400px" }
                    })
                  ],
                  1
                )
              ]),
              _c("el-table-column", {
                attrs: {
                  fixed: "left",
                  type: "selection",
                  width: "56",
                  "class-name": "paddingL20"
                }
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "roleId",
                    "min-width": "80",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.ToBreak(scope.row.roleId)
                                  )
                                },
                                slot: "content"
                              }),
                              _c("div", { staticClass: "line" }, [
                                _vm._v(_vm._s(scope.row.roleId))
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("角色编号")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "systemName",
                    "min-width": "80",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.ToBreak(scope.row.systemName)
                                  )
                                },
                                slot: "content"
                              }),
                              _c("div", { staticClass: "line" }, [
                                _vm._v(_vm._s(scope.row.systemName))
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("系统名称")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "roleName",
                    "min-width": "80",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.ToBreak(scope.row.roleName)
                                  )
                                },
                                slot: "content"
                              }),
                              _c("div", { staticClass: "line" }, [
                                _vm._v(_vm._s(scope.row.roleName))
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("角色名称")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "roleDescription", "min-width": "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.ToBreak(scope.row.roleDescription)
                                  )
                                },
                                slot: "content"
                              }),
                              _c("div", { staticClass: "line" }, [
                                _vm._v(_vm._s(scope.row.roleDescription))
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("角色说明")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "canSetManageOrg", "min-width": "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.ToBreak(
                                      scope.row.canSetManageOrg === 0
                                        ? "否"
                                        : "是"
                                    )
                                  )
                                },
                                slot: "content"
                              }),
                              _c("div", { staticClass: "line" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("filterNumberType")(
                                        scope.row.canSetManageOrg
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("是否设定管辖部门")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "canSetBizLine", "min-width": "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.ToBreak(
                                      scope.row.canSetBizLine === 0
                                        ? "否"
                                        : "是"
                                    )
                                  )
                                },
                                slot: "content"
                              }),
                              _c("div", { staticClass: "line" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("filterNumberType")(
                                        scope.row.canSetBizLine
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("是否开启条线选择")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "roleStatus.value",
                    "show-overflow-tooltip": "",
                    "min-width": "100"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", {
                            class:
                              scope.row.roleStatus.key == "VALID"
                                ? "statusicon"
                                : "unstatusicon"
                          }),
                          _c("span", { staticClass: "statustitle" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.roleStatus.key == "VALID"
                                    ? "有效"
                                    : "失效"
                                ) +
                                " "
                            )
                          ])
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("角色状态")
                    ])
                  ])
                ],
                2
              ),
              _c("el-table-column", {
                attrs: { label: "操作", fixed: "right", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "op-tips",
                            staticStyle: {
                              display: "flex",
                              color: "var(--mainColor)",
                              cursor: "pointer"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "op-item ",
                                on: {
                                  click: function($event) {
                                    return _vm.editRoleDialog(scope)
                                  }
                                }
                              },
                              [_vm._v(" 编辑 ")]
                            ),
                            _c(
                              "div",
                              { staticStyle: { margin: "-1px 4px 0" } },
                              [_vm._v("|")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "op-item op-see",
                                on: {
                                  click: function($event) {
                                    return _vm.checkRoleDetail(scope)
                                  }
                                }
                              },
                              [_vm._v(" 查看 ")]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _c("div", { staticClass: "footer-page-role" }, [
        _c(
          "div",
          { staticClass: "role-footer-left" },
          [
            _c(
              "el-popconfirm",
              {
                attrs: { title: "删除角色无法恢复，是否要删除？" },
                on: {
                  onConfirm: function($event) {
                    return _vm.delRole()
                  }
                }
              },
              [
                _c("input", {
                  staticClass: "btn btn-del",
                  staticStyle: { "margin-left": "0px" },
                  attrs: { slot: "reference", type: "button", value: "删除" },
                  slot: "reference"
                })
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "role-footer-right" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
                "current-page": _vm.pageNum,
                "page-sizes": [10, 20, 50, 100, 1000, 2000],
                "hide-on-single-page": false
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.pageNum = $event
                },
                "update:current-page": function($event) {
                  _vm.pageNum = $event
                },
                "current-change": _vm.currentChange,
                "size-change": _vm.sizeChange
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "382px",
            title: "删除角色",
            visible: _vm.ifShowDelDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.ifShowDelDialog = $event
            }
          }
        },
        [
          _c("del-dialog", {
            attrs: {
              tips1: "确定要删除所选角色吗？",
              tips2: "删除角色后无法恢复，是否要删除角色"
            },
            on: {
              cancle: function($event) {
                _vm.ifShowDelDialog = false
              },
              commit: _vm.delRole
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }